import classes from "./AccountQuestions.module.css";

const AccountQuestions = () => {
  return (
    <div className={classes.otherQuestion}>
      <h4>有其他問題歡迎與我們聯絡😊</h4>
      <address className={classes.address}>
        <div className={classes.address__part}>
          <h4>地址</h4>
          <p>新北市汐止區新台五路一段79號5F-5(遠東世界中心C棟)</p>
        </div>
        <div className={classes.address__part}>
          <h4>
            <a href="mailto:#">信箱</a>
          </h4>
          <p>test@gmail.com</p>
        </div>
        <div className={classes.address__part}>
          <h4>電話</h4>
          <p>
            <a href="tel:+886-2-8698-3838">886-2-8698-3838</a>
          </p>
        </div>
        <div className={classes.address__part}>
          <h4>傳真</h4>
          <p>
            <a href="fax:+886-2-8698-3636">886-2-8698-3636</a>
          </p>
        </div>
      </address>
    </div>
  );
};

export default AccountQuestions;
